import { j as r } from "./kezios-design-system.esm172.js";
import m from "react";
import { Flex as i, Stack as o, Text as e } from "@mantine/core";
import c from "./kezios-design-system.esm211.js";
import { Spacing as n } from "./kezios-design-system.esm135.js";
const j = ({ avatar: t, name: s, subText: a }) => /* @__PURE__ */ r.jsxs(i, { align: "center", gap: n.s3, children: [
  t && m.cloneElement(t, { className: c.avatar }),
  /* @__PURE__ */ r.jsxs(o, { gap: 0, children: [
    /* @__PURE__ */ r.jsx(e, { variant: "textSm.semibold", c: "gray.9", children: s }),
    /* @__PURE__ */ r.jsx(e, { variant: "textSm", c: "gray.6", children: a })
  ] })
] });
export {
  j as UserCard
};
